
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AudienceCategory, AudienceParameters } from 'src/app/models/services/audience';
import { AudiencesService } from 'src/app/services/audiences/audiences.service';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-audience-parameters-dialog',
  templateUrl: './audience-parameters-dialog.component.html',
  styleUrls: ['./audience-parameters-dialog.component.sass']
})
export class AudienceParametersDialogComponent implements OnInit {

  public accept: (data: AudienceParameters) => void;
  public dismiss: () => void;
  public audienceParameters?: AudienceParameters;
  public isUpdate: boolean;

  form: FormGroup;
  name: string;
  title: string = "Create audience"; 
  audiencesCategories: AudienceCategory[] = [];
  currentCategoryDescription: string = "Select a category";

  constructor(
    public usersService: UsersService,
    private audiencesServices: AudiencesService,
    private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group(
      {
        categoryId: ['', Validators.required],
        name: ['', Validators.required]
      });
  }

  ngOnInit(): void {
    this.isUpdate = !!this.audienceParameters;
    this.audiencesServices.getAudiencesCategories().subscribe(
      resp => {
        this.audiencesCategories = resp;
        if (!!this.audienceParameters) {
          this.title = "Update audience";
          this.form.controls.name.setValue(this.audienceParameters.name);
          let audienceCategory: AudienceCategory = this.audiencesCategories.find(x => x.id == this.audienceParameters.categoryId);
          if (!!audienceCategory) {
            this.form.controls.categoryId.setValue(audienceCategory.id);
          }   

        }
      }
    )
  }

  selectCategory = (category: AudienceCategory): void => {
    this.form.controls.categoryId.setValue(category.id);
  }


  onAccept = (): void => {    
    let result: AudienceParameters = {
      categoryId: +this.form.controls.categoryId.value,
      name: this.form.controls.name.value
    };

    this.accept(result);
  };

  onDismiss = (): void => {
    this.dismiss();
  }

  filterValidDates = (d: Date): boolean => {
    if (!!!d)
      return false;

    return d > new Date();
  }    
}


